import React from 'react';
import Dialog from '../../common/components/Dialog';
import { useTranslations } from '../../localization/useTranslations';

interface PrintContentLockProps {
  isOpen: boolean;
}

const PrintContentLock: React.FC<PrintContentLockProps> = ({ isOpen }) => {
  const translations = useTranslations();

  const { printModalData } = window;

  const labelWithoutPTags = printModalData?.content_lock_modal_link_label?.replace(/<\/?p>/g, '') || 'Back to Forbes';
  const subscriptionSlug = window?.subscriptionPageSlug || 'predplatne';

  return (
    <Dialog isOpen={isOpen}>
      <div className="modal modal--small content-lock-modal">
        <div className="modal__wrapper">
          <div className="modal__header content-lock-modal__header">
            <h5>
              {translations.printContentLockModal?.noAccessToThisContent || "You don't have access to this content"}
            </h5>
          </div>

          <div className="content-lock-modal__content modal__content">
            <div className="content-lock-modal__description basic-16">
              {translations.printContentLockModal?.modalMessage ||
                'To view articles from the Forbes print magazine, you must have an account with an active business subscription.'}
            </div>
          </div>

          <div className="content-lock-modal__footer">
            <a href={`/${subscriptionSlug}`} className="content-lock-modal__link link-16">
              {translations.printContentLockModal?.buyASubscription || 'Buy a subscription'}
            </a>
            <a
              href={printModalData?.content_lock_modal_link_url || '/'}
              className="content-lock-modal__link content-lock-modal__link--secondary link-16"
            >
              {labelWithoutPTags}
            </a>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PrintContentLock;
